export enum ErrorSeverities {
    WARNING = 'warning',
    ABORT = 'abort',
}
